import React from 'react'
import { Input } from '../../../components/ui/Input';
import Title from '../../../components/ui/Title';

const AddressDetails = ({ addressDetails }) => {
    const {
        address,
        addressErrors,
        addressInputs
    } = addressDetails;

    return (
        <React.Fragment>
            <Title text1='Dados' text2='Residenciais' />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-5">
                {addressInputs.map((input, i) => {
                    const fieldName = input.name;
                    const error = addressErrors[fieldName];
                    return (
                        <div>
                            <Input
                                type={input.type}
                                label={input.label}
                                placeholder={input.placeholder}
                                value={input.value}
                                onChange={input.onChange}
                                className={input.className}
                                name={input.name}
                                key={i}
                            />
                            {error && <span className="w-full text-start text-red-500 text-sm">{error}</span>}
                        </div>
                    );
                })}
            </div>
        </React.Fragment>
    )
}

export default AddressDetails